package com.nonopn.skydome.management.app.home

import androidx.compose.runtime.Composable
import com.nonopn.skydome.common.app.home.AppCommon
import com.nonopn.skydome.common.app.home.AppModelManager
import com.nonopn.skywatcher.app.utils.AppBackPressProvider

@Composable
fun App(
    isDarkTheme: Boolean,
    onBackPressed: AppBackPressProvider = AppBackPressProvider()
) {
    AppCommon(
        isDarkTheme = isDarkTheme,
        onBackPressed = onBackPressed
    ) { isSystemDarkTheme -> AppModelManager(isSystemDarkTheme) }
}
